import React from "react";
import "./../styles/globals/global.scss";

function MainLogoContainer() {
  return (
    <div className="mainLogoContainerMobile">
      <div
        className="is-flex is-flex-direction-column is-justify-content-space-between imageDiv"
        style={{
          width: "560px",
          backgroundImage: `url('/images/logo.jpg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100%",
        }}
      >
        <img
          style={{ width: "225px" }}
          src="/images/mini-logo.png"
          alt="Logo"
        />
      </div>
    </div>
  );
}

export default MainLogoContainer;
